export const getDateData = (inputStr: string) => {
  if (!inputStr) {
    return null;
  }

  const parts = inputStr.split("-");
  let year: number, month: number, day: number;

  if (parts.length === 2) {
    [year, month] = parts.map(Number);
    day = 1;
  } else if (parts.length === 3) {
    [year, month, day] = parts.map(Number);
  } else {
    throw new Error("Invalid date format. Use 'YYYY-MM' or 'YYYY-MM-DD'.");
  }

  const date = new Date(year, month - 1, day);
  const now = new Date();

  let fullYears = now.getFullYear() - date.getFullYear();
  let fullMonths = now.getMonth() - date.getMonth();

  if (fullMonths < 0) {
    fullYears -= 1;
    fullMonths += 12;
  }

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  return {
    fullYears,
    year,
    monthNames: monthNames[month - 1],
    fullMonths: fullMonths + 1,
    day,
  };
};
